import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
    tabSpace,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson3DefaultStartCode = `%lang starknet
// Functions and other definitions can be scoped in namespaces, making the code more readable.

// Defining a namespace
namespace my_namespace {
    func returns_something() -> (result : felt) {
        return (result=42);
    }
}

@external
func test_hello{syscall_ptr : felt*}() {
${tabSpace}${doNotModifyCodeAbove}`;

export const lesson3DefaultMiddleCode = `${tabSpace}// TODO: Change the following line to make the test pass
${tabSpace}let (result) = returns_something();`;

export const lesson3DefaultEndCode = `${tabSpace}${doNotModifyCodeBelow}
    assert result = 42;
    return ();
}`;
